import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=0f96e9bf&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "./Income.vue?vue&type=style&index=0&id=0f96e9bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96e9bf",
  null
  
)

/* custom blocks */
import block0 from "./Income.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports